<template>
    <input v-model='value' ref='input' @input="input"/>
</template>

<script>
export default {
    name: "autoinput",
    data: ()=>({
        value: ''
    }),
    methods: {
        input () {
            // console.log(this.$refs.input.style.fontSize)
        }
    },
    watch: {
        value (val) {
            // console.log(val)
        }
    }
};
</script>

<style scoped>

</style>
